export const portaleTurystyczne = {
  page: {
    response: {
      innepanstwa: [
        {
          maindata: {
            name: "Austria",
            urlgeo: "/austria.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "austria",
            grupa: "1",
            url: "https://www.austria.pl",
            photo: "AT-01.jpg",
            cenamin: "82"
          },
          Opis:
            "Alpy i znakomita infrastruktura narciarska czynią ten kraj rajem dla narciarzy i snowboardzistów. Na amatorów letnich wypraw czekają kilometry szlaków górskich, tras rowerowych oraz wyciągów. Wiedeń, park rozrywki Prater oraz Salzburg Mozarta to obowiązkowe punkty programów wycieczek objazdowych po Austrii.",
          Polecamy: [
            {
              name: "Wiedeń",
              url: "https://www.austria.pl/wieden.xml"
            },
            {
              name: "park rozrywki Prater",
              url: "https://www.austria.pl/wieden-wiener-prater.xml"
            },
            {
              name: "Salzburg",
              url: "https://www.austria.pl/salzburg.xml"
            },
            {
              name: "Alpy",
              url: ""
            },
            {
              name: "Pałac Schönbrunn",
              url: ""
            },
            {
              name: "Pałac Hofburg",
              url: "https://www.austria.pl/wieden-palac-hofburg.xml"
            },
            {
              name: "Belweder",
              url: ""
            },
            {
              name: "dom Mozarta",
              url: ""
            },
            {
              name: "Dolina Wachau i trasa kolei wysokogórskiej (UNESCO)",
              url: "https://www.austria.pl/wachau-dolina-dunaju.xml"
            },
            {
              name: "jeziora w Karyntii",
              url: "https://www.austria.pl/karyntia.xml"
            }
          ],
          Atrakcje: [
            {
              name: "narciarstwo i snowboard",
              url: "https://www.austria.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "wycieczki górskie",
              url: ""
            },
            {
              name: "trasy rowerowe",
              url: ""
            },
            {
              name: "nordic walking",
              url: "https://www.austria.pl/rodzaj-oferty/nordic-walking.xml"
            },
            {
              name: "wycieczki piesze",
              url: ""
            },
            {
              name: "city breaks",
              url: "https://www.austria.pl/rodzaj-oferty/city-breaks.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Bułgaria",
            urlgeo: "/bulgaria.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "bulgaria",
            grupa: "1",
            url: "https://www.bulgaria.pl",
            photo: "BG-01.jpg",
            cenamin: "99"
          },
          Opis:
            "Doskonałe warunki na rodzinne i niedrogie wakacje: latem – ciepłe, spokojne morze oraz długie, szerokie plaże w Słonecznym Brzegu i Złotych Piaskach, zimą – szaleństwo na stokach narciarskich w górach Pirin i Riła. Miasto-muzeum Nessebar, historyczna Warna lub Święty Włas to jedne z najciekawszych atrakcji Bułgarii.",
          Polecamy: [
            {
              name: "Nessebar",
              url: "https://www.bulgaria.pl/nesebyr.xml"
            },
            {
              name: "Sozopol",
              url: "https://www.bulgaria.pl/sozopol.xml"
            },
            {
              name: "Warna",
              url: "https://www.bulgaria.pl/warna.xml"
            },
            {
              name: "Góry Bałkan",
              url: "https://www.bulgaria.pl/gory-balkan-stara-planina.xml"
            },
            {
              name: "Góry Pirin",
              url: "https://www.bulgaria.pl/gory-pirin.xml"
            },
            {
              name: "Góry Riła",
              url: "https://www.bulgaria.pl/masyw-rila.xml"
            },
            {
              name: "Słoneczny Brzeg",
              url: "https://www.bulgaria.pl/sloneczny-brzeg-nesebyr.xml"
            },
            {
              name: "Złote Piaski",
              url: "https://www.bulgaria.pl/zlote-piaski-albena.xml"
            },
            {
              name: "Sofia i okolice",
              url: "https://www.bulgaria.pl/region-sofia.xml"
            }
          ],
          Atrakcje: [
            {
              name: "sporty wodne",
              url:
                "http://www.bulgaria.pl/rodzaj-oferty/sporty-wodne-w-bulgarii.xml"
            },
            {
              name: "nurkowanie",
              url: ""
            },
            {
              name: "wędrówki górskie",
              url: ""
            },
            {
              name: "narciarstwo",
              url:
                "http://www.bulgaria.pl/rodzaj-oferty/kurorty-narciarskie-w-bulgarii.xml"
            },
            {
              name: "wycieczki ze zwiedzaniem",
              url:
                "http://www.bulgaria.pl/rodzaj-oferty/wycieczki-objazdowe-po-bulgarii.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Czechy",
            urlgeo: "/czechy.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "czechy",
            grupa: "1",
            url: "https://www.czechy.pl",
            photo: "CZ-01.jpg",
            cenamin: "105"
          },
          Opis:
            "Praga ze swymi zabytkami i charakterystycznymi czerwonymi dachami, skalne miasta Czeskiego Raju, światowej sławy uzdrowiska i gorące źródła, świetna infrastruktura narciarska oraz piwo i tradycyjne przysmaki kuchni czeskiej - to tylko niektóre z zalet tego pięknego kraju. Popularna destynacja na wyjazdy weekendowe.",
          Polecamy: [
            {
              name: "Praga",
              url: "https://www.czechy.pl/praga.xml"
            },
            {
              name: "Czeski Krumlov",
              url: "https://www.czechy.pl/czeski-krumlov.xml"
            },
            {
              name: "Karlowe Wary",
              url: "https://www.czechy.pl/karlovy-vary-karlowe-wary.xml"
            },
            {
              name: "Kutna Hora",
              url: "https://www.czechy.pl/kutna-hora.xml"
            },
            {
              name: "Harrachov",
              url: "https://www.czechy.pl/harrachov.xml"
            }
          ],
          Atrakcje: [
            {
              name: "trekking",
              url: ""
            },
            {
              name: "trasy rowerowe",
              url: ""
            },
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "wyjazdy sportowe",
              url: "https://www.czechy.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "narty",
              url: "https://www.czechy.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "city breaks",
              url: "https://www.czechy.pl/rodzaj-oferty/city-breaks.xml"
            },
            {
              name: "nordic walking",
              url: "https://www.czechy.pl/rodzaj-oferty/nordic-walking.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Francja",
            urlgeo: "/francja.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "francja",
            grupa: "1",
            url: "https://www.francja.pl",
            photo: "FR-01.jpg",
            cenamin: "82"
          },
          Opis:
            "Wyrafinowana kultura i sztuka, także kulinarna, winnice, perfumy i pola lawendy! Szyk Paryża, luksus Lazurowego Wybrzeża, festiwale muzyczne, filmowe i teatralne, tajemnicze średniowieczne zamki i miasta, wysokie Alpy z licznymi lodowcami – Francja to wizytówka europejskiej kultury, kraj malowniczych krajobrazów i ciekawej historii.",
          Polecamy: [
            {
              name: "Paryż",
              url: "https://www.francja.pl/paryz-metropolia.xml"
            },
            {
              name: "Lazurowe Wybrzeże",
              url: "https://www.francja.pl/lazurowe-wybrzeze.xml"
            },
            {
              name: "Cannes",
              url: "https://www.francja.pl/cannes.xml"
            },
            {
              name: "zamki nad Loarą",
              url: "https://www.francja.pl/region-loary.xml"
            },
            {
              name: "Korsyka",
              url: "https://www.francja.pl/korsyka.xml"
            },
            {
              name: "Alpy",
              url: "https://www.francja.pl/alpy-francuskie.xml"
            }
          ],
          Atrakcje: [
            {
              name: "narty i snowboard",
              url: "https://www.francja.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "plazowanie",
              url:
                "https://www.francja.pl/rodzaj-oferty/hotele-blisko-plazy.xml"
            },
            {
              name: "sporty wodne",
              url: "https://www.francja.pl/rodzaj-oferty/sporty-wodne.xml"
            },
            {
              name: "luksusowe wczasy",
              url: ""
            },
            {
              name: "city breaks",
              url: "https://www.francja.pl/rodzaj-oferty/city-breaks.xml"
            },
            {
              name: "życie nocne",
              url: "https://www.francja.pl/rodzaj-oferty/zycie-nocne.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Słowacja",
            urlgeo: "/oferta/szukaj.xml?extern=1&sort=0",
            urlof: "/slowacja.xml",
            id: "slowacja",
            grupa: "1",
            url: "https://www.slowacja.com.pl",
            photo: "SK-01.jpg",
            cenamin: "100"
          },
          Opis:
            "Ośnieżone szczyty Tatr, Słowacki Raj, Spisz, warowne zamki, malownicze jeziora, tajemnicze jaskinie, parki wodne oraz uzdrowiska z basenami termalnymi. Słowacja to bogaty kulturowo i przyrodniczo kraj ze świetnymi warunkami do uprawiania sportów oraz znakomitą infrastrukturą narciarską. Blisko i tanio!",
          Polecamy: [
            {
              name: "Aquapark Tatralandia",
              url: ""
            },
            {
              name: "Chopok",
              url: "https://www.slowacja.com.pl/chopok.xml"
            },
            {
              name: "Strbskie Pleso",
              url: "https://www.slowacja.com.pl/strbske-pleso.xml"
            }
          ],
          Atrakcje: [
            {
              name: "turystyka piesza i rowerowa",
              url: ""
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.slowacja.com.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "narty",
              url:
                "http://www.slowacja.com.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "zwiedzanie jaskiń",
              url: ""
            },
            {
              name: "city breaks",
              url: ""
            },
            {
              name: "na weekend",
              url:
                "http://www.slowacja.com.pl/rodzaj-oferty/wyjazdy-weekendowe.xml"
            },
            {
              name: "nordic walking",
              url:
                "https://www.slowacja.com.pl/rodzaj-oferty/nordic-walking.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Słowenia",
            urlgeo: "/slowenia.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "slowenia",
            grupa: "1",
            url: "https://www.slowenia.info.pl",
            photo: "SI-01.jpg",
            cenamin: "173"
          },
          Opis:
            "Maleńki i bardzo różnorodny kraj – włoskie miasteczka na wybrzeżu, romantyczna Lublana, malownicze krajobrazy, jeziora, niziny, kras i Alpy Julijskie. Do tego znakomite warunki do uprawiania sportów ekstremalnych oraz wysoki standard hoteli i luksusowe ośrodki SPA.",
          Polecamy: [
            {
              name: "Piran",
              url: "https://www.slowenia.info.pl/piran.xml"
            },
            {
              name: "Portorož",
              url: "https://www.slowenia.info.pl/portoroz.xml"
            },
            {
              name: "jaskinia w Postojnej",
              url: "https://www.slowenia.info.pl/jaskinia-postojna.xml"
            },
            {
              name: "Bohinj",
              url: "https://www.slowenia.info.pl/bohinj.xml"
            },
            {
              name: "Bled",
              url: "https://www.slowenia.info.pl/bled.xml"
            },
            {
              name: "Planica w Alpach",
              url: "https://www.slowenia.info.pl/planica.xml"
            }
          ],
          Atrakcje: [
            {
              name: "narty",
              url:
                "http://www.slowenia.info.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.slowenia.info.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "trekking",
              url: ""
            },
            {
              name: "mountainbike",
              url: ""
            },
            {
              name: "kajaki",
              url: ""
            },
            {
              name: "paralotnie",
              url: ""
            },
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "życie nocne",
              url: ""
            },
            {
              name: "objazdówki",
              url: ""
            },
            {
              name: "city breaks",
              url: ""
            }
          ]
        },
        {
          maindata: {
            name: "Włochy",
            urlgeo: "/wlochy.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "wlochy",
            grupa: "1",
            url: "https://www.wlochy.pl",
            photo: "IT-01.jpg",
            cenamin: "59"
          },
          Opis:
            "Poetycka Toskania, tajemniczy Watykan, historyczny Rzym i Neapol, Sycylia, śródziemnomorska kuchnia, lodowce w Dolomitach i skąpane w słońcu plaże Kalabrii. Bardzo zróżnicowana oferta turystyczna Włoch obejmuje zabytki i historyczne miejsca oraz kurorty nadmorskie i narciarskie.",
          Polecamy: [
            {
              name: "Rzym",
              url: "https://www.wlochy.pl/rzym.xml"
            },
            {
              name: "Wenecja",
              url: "https://www.wlochy.pl/wenecja.xml"
            },
            {
              name: "Watykan",
              url: "https://www.wlochy.pl/watykan.xml"
            },
            {
              name: "Amalfi",
              url: "https://www.wlochy.pl/wybrzeze-amalfi.xml"
            },
            {
              name: "Pompeje",
              url: "https://www.wlochy.pl/pompeje.xml"
            },
            {
              name: "Werona",
              url: "https://www.wlochy.pl/werona.xml"
            },
            {
              name: "włoska kuchnia",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "windsurfing",
              url:
                "http://www.wlochy.pl/rodzaj-oferty/kite-windsurfing-we-wloszech.xml"
            },
            {
              name: "rowery",
              url: ""
            },
            {
              name: "wspinaczka i trekking",
              url: ""
            },
            {
              name: "narty",
              url:
                "http://www.wlochy.pl/rodzaj-oferty/wyjazdy-na-narty-do-wloch.xml"
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.wlochy.pl/rodzaj-oferty/sport-we-wloszech.xml"
            },
            {
              name: "city breaks",
              url:
                "http://www.wlochy.pl/rodzaj-oferty/hotele-blisko-centrum-miejscowosci-we-wloszech.xml"
            },
            {
              name: "objazdówki",
              url:
                "http://www.wlochy.pl/rodzaj-oferty/wycieczki-objazdowe-po-wloszech.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Szwajcaria",
            urlgeo: "/szwajcaria.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "szwajcaria",
            grupa: "1",
            url: "https://www.szwajcaria.com.pl",
            photo: "CH-01.jpg",
            cenamin: "268"
          },
          Opis:
            "„Dom gór” – Szwajcaria znana jest ze znakomitych warunków narciarskich. Słynie także z banków, zegarków, demokracji i neutralności. Wielokulturowa Szwajcaria to także tradycyjne miasteczka, historyczna zabudowa miast i zabytki do Berna, Bazylei, Zurychu, Lozanny czy Fryburgu. Lodowiec Matterhorn to popularne miejsce wśród narciarzy.",
          Polecamy: [
            {
              name: "Berno",
              url: "https://www.szwajcaria.com.pl/berno.xml"
            },
            {
              name: "Zurych",
              url: "https://www.szwajcaria.com.pl/zurych.xml"
            },
            {
              name: "Genewa",
              url: "https://www.szwajcaria.com.pl/genewa.xml"
            },
            {
              name: "Lozanna",
              url: "https://www.szwajcaria.com.pl/lozanna.xml"
            },
            {
              name: "Alpy",
              url: ""
            },
            {
              name: "lodowiec",
              url: ""
            },
            {
              name: "Jezioro Genewskie",
              url:
                "https://www.szwajcaria.com.pl/region-jeziora-genewskiego.xml"
            }
          ],
          Atrakcje: [
            {
              name: "wspinaczka",
              url: ""
            },
            {
              name: "narciarstwo",
              url:
                "http://www.szwajcaria.com.pl/rodzaj-oferty/wyjazdy-na-narty.xml"
            },
            {
              name: "zwiedzanie i objazdówki",
              url:
                "http://www.szwajcaria.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "aktywny wypoczynek",
              url: "https://www.szwajcaria.com.pl/rodzaj-oferty/sport.xml"
            },
            {
              name: "nordic walking",
              url:
                "http://www.szwajcaria.com.pl/rodzaj-oferty/nordic-walking.xml"
            }
          ]
        },
        {
          maindata: {
            name: "Niemcy",
            urlgeo: "/niemcy.xml",
            urlof: "/oferta/szukaj.xml?extern=1&sort=0",
            id: "niemcy",
            grupa: "1",
            url: "https://www.niemcy.com.pl",
            photo: "DE-01.jpg",
            cenamin: "109"
          },
          Opis:
            "Kraj piwa i Oktoberfestu, zamków bawarskich oraz zabytkowych miast, takich jak Berlin i Monachium. Niemcy są dobrą propozycją na wyjazd o każdej porze roku – liczne górskie kurorty, ciekawe wybrzeże Morza Bałtyckiego i Północnego oraz bogata kultura i historia. Kraj popularny na wyjazdy weekendowe.",
          Polecamy: [
            {
              name: "Berlin",
              url: "https://www.niemcy.com.pl/berlin.xml"
            },
            {
              name: "Hamburg",
              url: "https://www.niemcy.com.pl/hamburg.xml"
            },
            {
              name: "Kolonia",
              url: "https://www.niemcy.com.pl/kolonia.xml"
            },
            {
              name: "Bonn",
              url: "https://www.niemcy.com.pl/bonn.xml"
            },
            {
              name: "Monachium",
              url: "https://www.niemcy.com.pl/monachium.xml"
            },
            {
              name: "Bawaria",
              url: "https://www.niemcy.com.pl/bawaria.xml"
            },
            {
              name: "Saksonia",
              url: "https://www.niemcy.com.pl/dolna-saksonia-brema.xml"
            },
            {
              name: "Szlezwik-Holsztyn",
              url: "https://www.niemcy.com.pl/szlezwik-holsztyn-hamburg.xml"
            },
            {
              name: "bawarskie zamki",
              url: ""
            },
            {
              name: "Oktoberfest",
              url: ""
            }
          ],
          Atrakcje: [
            {
              name: "wycieczki objazdowe",
              url:
                "http://www.niemcy.com.pl/rodzaj-oferty/wycieczki-objazdowe.xml"
            },
            {
              name: "city breaks",
              url: ""
            },
            {
              name: "narty",
              url:
                "http://www.niemcy.com.pl/rodzaj-oferty/kurorty-narciarskie.xml"
            },
            {
              name: "wyprawy górskie",
              url: ""
            }
          ]
        },
      ],
      grupypanstw: [
        {
          id: "1",
          name: "Europa"
        },
        {
          id: "2",
          name: "Bliski Wschód"
        },
        {
          id: "3",
          name: "Azja Południowa"
        },
        {
          id: "4",
          name: "Azja Południowo-Wschodnia"
        },
        {
          id: "5",
          name: "Australia i Oceania"
        },
        {
          id: "6",
          name: "Afryka Północna"
        },
        {
          id: "7",
          name: "Afryka Wschodnia"
        },
        {
          id: "8",
          name: "Afryka Południowa"
        },
        {
          id: "9",
          name: "Ameryka Środkowa i Karaiby"
        },
        {
          id: "10",
          name: "Ameryka Południowa"
        },
        {
          id: "11",
          name: "Ameryka Północna"
        }
      ]
    }
  }
};
